import { Modal } from '@nike/eds'
import { useGetRasnEventPayloadQuery } from 'api/event'
import { useMemo } from 'react'
import { JsonView, defaultStyles } from 'react-json-view-lite'
// Thank you EDS, you are loved and cared for
import 'react-json-view-lite/dist/index.css'
import './RasnEventPayloadVisualizer.css'
import { showSnackbar } from 'redux/slices/globalState'
import { dispatch } from 'redux/store'
import type { RasnEvent } from 'types'

// Custom JSON view styles extending the default styles
const customJsonStyles = {
  ...defaultStyles,
  container: 'json-view-container',
  childFieldsContainer: 'json-child-fields',
  label: 'json-label',
  punctuation: 'json-punctuation',
  stringValue: 'json-string-value',
  numberValue: 'json-number-value',
  booleanValue: 'json-boolean-value',
  nullValue: 'json-null-undefined-value',
  undefinedValue: 'json-null-undefined-value',
  clickableLabel: 'json-clickable-label'
}

export const RasnEventPayloadVisualizer = ({ rasnEvent, onClose }: { rasnEvent: RasnEvent | null, onClose: () => void }) => {
  if (!rasnEvent) return null
  const { data, isLoading, isError } = useGetRasnEventPayloadQuery(rasnEvent)
  
  const parsedPayload = useMemo(() => {
    if (!data || !data.payload) return null
    if (typeof data.payload !== 'string') return data.payload
    
    try {
      return JSON.parse(data.payload)
    } catch (error) {
      dispatch(showSnackbar({ message: 'Failed to parse payload JSON, displaying as text', status: 'error' }))
      console.error('Failed to parse payload JSON:', error)
      return data.payload
    }
  }, [data])
  
  return (
    <Modal isOpen={true} headerSlot={<h2 className="text-xl font-bold p-2">RASN Event Payload</h2>} onDismiss={onClose} hideFade={true} className="rasn-event-modal">
      <div className="force-fixed-width">
        { isLoading && (
          <div className="p-6 flex items-center justify-center h-64">
            <div className="animate-pulse text-blue-600 font-medium">Loading payload...</div>
          </div>
        )}
        { isError && (
          <div className="p-6 text-red-600 font-medium flex items-center justify-center h-64">
            <div>Failed to load payload</div>
          </div>
        )}
        { data && (
          <div className="p-6">
            <div className="json-view-container">
              <JsonView
                data={parsedPayload}
                style={customJsonStyles}
                clickToExpandNode={true}
              />
            </div>
          </div>
        )}
      </div>
    </Modal>
  )
}
